export type Tab = "profile" | "resources";

interface TabSwitchProps {
    currentTab: Tab;
    setCurrentTab: (tab: Tab) => void;
}

export const TabSwitch = ({ currentTab, setCurrentTab }: TabSwitchProps) => {
    return (
        <div className="flex flex-row my-[16px] border-b-2 border-[#E2E2E2] w-full">
            <div
                className={`pb-2 px-4 cursor-pointer text-sm font-medium text-left w-1/4 float-left ${currentTab === "profile"
                    ? "border-b-2 border-[#1C1C1C] text-[#1C1C1C]"
                    : "text-[#777777]"
                    }`}
                onClick={() => setCurrentTab("profile")}
            >
                Profile
            </div>
            <div
                className={`pb-2 px-4 cursor-pointer text-sm font-medium text-left w-1/4 float-left ${currentTab === "resources"
                    ? "border-b-2 border-[#1C1C1C] text-[#1C1C1C]"
                    : "text-[#777777]"
                    }`}
                onClick={() => setCurrentTab("resources")}
            >
                Resources
            </div>
        </div>
    );
}